import { Button, ButtonStyle } from '@davidlloydleisure/common-js-frontend';
import classNames from 'classnames';
import type { FC } from 'react';
import { use, useRef } from 'react';

import { ClubSearchInput } from 'src/components/common/club-search/club-search-input';
import { getButtonIcon } from 'src/components/facilities/link-button';
import { GlobalCmsContent } from 'src/content/global-content';
import { SiteContext } from 'src/context/site-context';
import { useClubSearchForm } from 'src/custom-hooks/use-club-search-form';
import { RedesignButtonIcon } from 'src/enums/button-icons';
import { getBrandForBuildType } from 'src/helpers/brand-for-build-type';

import * as style from './club-search.module.scss';

const ClubSearch: FC<{ isNavigation?: boolean; onFinish?: () => void }> = ({
  isNavigation,
  onFinish,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { buildType, isMeridian } = use(SiteContext);
  const { headerContent } = use(GlobalCmsContent);
  const buttonIcon = getButtonIcon(RedesignButtonIcon.SEARCH);
  const handleSubmit = useClubSearchForm(inputRef, true, onFinish);
  const brand = getBrandForBuildType(buildType);

  return (
    <form onSubmit={handleSubmit} className={style.wrapper}>
      <ClubSearchInput
        inputRef={inputRef}
        inputPlaceholder={headerContent.searchSettings.searchPlaceholderDesktop}
        pinnedSearchOptionText={headerContent.searchSettings.desktopPinnedSearchOptionText}
        isNavigation={isNavigation}
        onFinish={onFinish}
      />
      <Button
        isSubmit
        brand={brand}
        text={headerContent.searchSettings.openSearchButtonName ?? ''}
        style={ButtonStyle.PRIMARY}
        endIcon={buttonIcon}
        className={classNames(
          style.headerClubSearch,
          isMeridian && style.headerClubSearchMeridianButton
        )}
        focusBorderClassName={classNames(style.focusBorder)}
      />
    </form>
  );
};

export default ClubSearch;
